exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".odd{\n    background-color:#ffffff ;\n}\n.even{\n    background-color:#e6e6e6;\n}\n\ntable.bgborder, table.bgborder > thead > tr > th, table.bgborder > tbody > tr > td {\n    border: 1px solid #848a87;\n}\n\n.searchbox {\n    margin-right: 20px;\n    width: 135px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/templates/list-templates/list-templates.component.css
// module id = ../../../../../src/app/templates/list-templates/list-templates.component.css
// module chunks = main